import { ListingWithDetails } from "../types";
import { LocationData, MapMarkerData, Option } from "../types";

export function listingItemsToMapMarkers(
  listings: ListingWithDetails[],
  locations: Record<string, LocationData>
): MapMarkerData[] {
  // Listings can have multiple locations, so we gather markers for each location
  const markers: MapMarkerData[] = [];
  Object.values(listings).forEach((listing) => {
    listing.locations.forEach((loc) => {
      const locationData = locations[loc.locationId];
      if (locationData) {
        markers.push({
          id: `${listing.id}-${locationData.id}`,
          listingItemId: listing.id,
          coordinates: {
            lat: locationData.lat,
            lng: locationData.lng,
          },
          name: listing.name,
          itemType: listing.itemType,
        });
      }
    });
  });
  return markers;
}

export function mapToOptions(optionsMap: Record<string, string>): Option[] {
  return Object.entries(optionsMap).map(([value, label]) => ({ value, label }));
}
